module.exports = __webpack_public_path__ + "img/wsc_p9_img_16.f526530b.png";